import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles/skin.css';   // Rebranding 2026 · Mood Ivory Cream (ULTIMO per cascade override)
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
